import React, {useState, useEffect} from 'react'
import GeneralStyles from "../GeneralStyles.module.scss";
import PageHeader from "../../components/general/PageHeader";
import PositionedSnackbar from "../../components/general/PositionedSnackbar";
import {useDispatch, useSelector} from "react-redux";
import {API_CALL_STATUS} from "../../metadata/enums";
import {LOGGER} from "../../utils/Logger";
import moment from "moment";
import Colors from "../../config/colors";
import CustomLoaderSpinner from "../../components/general/CustomLoaderSpinner";
import {useNavigate} from "react-router-dom";
import CONSTANTS from "../../config/constants";
import Styles from "../WorkOrders/styles/UnderwritingDetails.module.scss";
import Helpers from "../../utils/helpers";
import CustomTextFieldNew from "../../components/general/CustomTextFieldNew";
import CustomButtonContained from "../../components/general/CustomButtonContained";
import ApiHelpers from "../../utils/ApiHelpers";
import CustomGooglePlacesNew from "../../components/general/CustomGooglePlacesNew";
import {geocodeByPlaceId} from 'react-google-places-autocomplete'
import {updateActiveUnderwriting, updateActiveUnderwritingId} from "../../redux/slices/workOrdersSlice";

const DATE_FORMAT = 'MMM Do, YYYY'

const Settings = () => {
	let navigate = useNavigate()
	let dispatch = useDispatch()

	const settingsState = useSelector(state => state.settings)
	const token = useSelector(state => state.auth.token)

	const [attomData, setAttomData] = useState(null)
	const [attomDataLoading, setAttomDataLoading] = useState(false)
	const [loading, setLoading] = useState(true)
	const [showSuccess, setShowSuccess] = useState(false)
	const [successMessage, setSuccessMessage] = useState('')
	const [errorMessage, setErrorMessage] = useState('')
	const [showError, setShowError] = useState(false)
	const [address1, setAddress1] = useState('')
	const [address2, setAddress2] = useState('')
	const [googleAddress, setGoogleAddress] = useState(null)


	useEffect(() => {
		if(settingsState.status === API_CALL_STATUS.LOADING) {
			setLoading(true)
		} else if(settingsState.status === API_CALL_STATUS.FAILED) {
			setLoading(true)
			setShowError(true)
			setErrorMessage('something went wrong when getting the settings data')
			LOGGER.error('error effect', settingsState.error)
		} else {
			setLoading(false)
		}
	},[settingsState])

	const navigateToUnderwritingDetails = (address1, city, state, postalCode) => {
		let temp = {
			work_order_subject: "",
			work_order_description: "",
			work_order_status: "",
			work_order_urgency: "",
			work_order_cost: "",
			work_order_custom_data: "",
			work_order_tags: "",
			work_order_created_at: "",
			work_order_updated_at: "",
			work_order_unit_id: "",
			property_id: "",
			property_name: "",
			property_category: "",
			property_address_display: "",
			property_address_line_one: address1,
			property_address_city: city,
			property_address_region: state,
			property_address_postal_code: postalCode,
			property_address_latitude: "",
			property_address_longitude: "",
			property_bedrooms: "",
			property_bathrooms: "",
			property_square_feet: "",
			property_status: "",
			lease_end_date: "",
			lease_start_date: "",
			work_order_type: "",
		}
		setLoading(false)
		dispatch(updateActiveUnderwritingId(-1))
		dispatch(updateActiveUnderwriting(temp))
		navigate('/home/underwriting-details')
	}

	const onSearchPressed = async() => {
		if(!googleAddress || !googleAddress.value) {
			setErrorMessage('Please enter an address')
      setShowError(true)
      return
		}
		try {
			setLoading(true)
			let {main_text, secondary_text} = googleAddress.value?.structured_formatting
			let placeId = googleAddress.value?.place_id
			let address1 = main_text
			let components = secondary_text?.split(',')
			let city = components[0]?.trim()
			let state = components[1]?.trim()

			let results = await geocodeByPlaceId(placeId)
			let addressComponents = results[0]?.address_components
			let postalCode = addressComponents.find(c => c.types.includes('postal_code'))?.long_name
			navigateToUnderwritingDetails(address1, city, state, postalCode)

		}catch(err) {
			LOGGER.error('Error when getting postal code')
			setErrorMessage(`Error when getting address components - ${err.message}`)
			setShowError(true)
		}

	}

	const renderAttomData = () => {
		if(attomDataLoading)
			return (
				<div style={{ height: '20vh', display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'row'}}>
					<CustomLoaderSpinner />
				</div>
			)

		if(!attomData)
			return null

		let owner = attomData?.owner || {}
		let owners = (owner.owner1?.fullname ? owner.owner1.fullname : '')
			+ (owner?.owner2?.fullname ? ', '+owner.owner2.fullname : '')
			+ (owner?.owner3?.fullname ? ', '+owner.owner3.fullname : '')
			+ (owner?.owner4?.fullname ? ', '+owner.owner4.fullname : '')
		let sale = attomData?.sale || {}
		let mortgage = attomData?.mortgage || {}
		let rentalAvm = attomData?.rentalAvm || {}
		let salesAvm = attomData?.avm || {}
		let building = attomData?.building || {}
		return (
			<div style={{width: '100%', border: `1px solid ${Colors.tableLineColor}`, borderRadius: 10, padding: '10px 0px', marginTop: 40}}>
				<p style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>ATTOM Data</p>
				<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
					<div style={{width: '48%', padding: '0px 8px'}}>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Year Built</p>
							<p className={Styles.entryText}>{attomData?.summary?.yearbuilt}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Property Condition</p>
							<p className={Styles.entryText}>{attomData?.building?.construction?.condition}</p>
						</div>

						<div className={Styles.row}>
							<p className={Styles.labelText}>Bedrooms</p>
							<p className={Styles.entryText}>{`${building?.rooms?.beds || ''}`}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Bathrooms</p>
							<p className={Styles.entryText}>{`${building?.rooms?.bathstotal || ''}`}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Area</p>
							<p className={Styles.entryText}>{`${building?.size?.universalsize || ''} ${building?.size?.sizeInd || ''}`}</p>
						</div>

						<div className={Styles.row}>
							<p className={Styles.labelText}>Owner(s)</p>
							<p className={Styles.entryText}>{owners ? owners : ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Mailing Address</p>
							<p className={Styles.entryText}>{owner?.mailingaddressoneline}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Sale Details</p>
							<p className={Styles.entryText}>{sale && sale.amount ? `$${Helpers.getFormattedNumber(sale.amount.saleamt || 0)} on ${moment(sale.amount.salerecdate).format(DATE_FORMAT)}` : ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Mortgage Amount</p>
							<p className={Styles.entryText}>{mortgage?.amount ? `${Helpers.getFormattedNumber(mortgage?.amount || 0)}`: ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Term</p>
							<p className={Styles.entryText}>{mortgage?.term ? `${mortgage.term}`: ''}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Start & End</p>
							<p className={Styles.entryText}>{mortgage?.amount ? `${moment(mortgage.date).format(DATE_FORMAT)} & ${moment(mortgage.duedate).format(DATE_FORMAT)}` : ''}</p>
						</div>
					</div>

					<div style={{borderRight: `1px solid ${Colors.tableLineColor}`}}/>

					<div style={{width: '48%', padding: '0px 8px'}}>
						<p style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Rental AVM</p>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Estimated Date</p>
							<p className={Styles.entryText}>{rentalAvm?.valuationDate}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Rental Value</p>
							<p className={Styles.entryText}>${Helpers.getFormattedNumber(rentalAvm?.estimatedRentalValue || 0)}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Min Rental Value</p>
							<p className={Styles.entryText}>${Helpers.getFormattedNumber(rentalAvm?.estimatedMinRentalValue || 0)}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Max Rental Value</p>
							<p className={Styles.entryText}>${Helpers.getFormattedNumber(rentalAvm?.estimatedMaxRentalValue || 0)}</p>
						</div>

						<div style={{width: '100%', borderBottom: `1px solid ${Colors.tableLineColor}`, marginTop: 10, marginBottom: 10}}/>
						<p style={{width: '100%', textAlign: 'center', fontSize: CONSTANTS.headerSize, fontWeight: 'bold', color: Colors.primaryTextColor}}>Sales AVM</p>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Estimated Date</p>
							<p className={Styles.entryText}>{salesAvm?.eventDate}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Sale Value</p>
							<p className={Styles.entryText}>${Helpers.getFormattedNumber(salesAvm?.amount?.value || 0)}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Min Sale Value</p>
							<p className={Styles.entryText}>${Helpers.getFormattedNumber(salesAvm?.amount?.low || 0)}</p>
						</div>
						<div className={Styles.row}>
							<p className={Styles.labelText}>Max Sale Value</p>
							<p className={Styles.entryText}>${Helpers.getFormattedNumber(salesAvm?.amount?.high || 0)}</p>
						</div>
					</div>
				</div>
			</div>
		)
	}

	const renderContent = () => {
		return (
			<div>
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%'}}>
					<div style={{ width: '50%' }}>
						<CustomGooglePlacesNew
							placeholder={'Search Address...'}
							value={googleAddress}
							onChange={(value) => {
								console.log('address', value)
								setGoogleAddress(value)
							}}
						/>
					</div>
					{/*<CustomTextFieldNew*/}
					{/*	width={'30%'}*/}
					{/*	label={"Address 1"}*/}
					{/*	placeholder={'2215 W Boston Blvd'}*/}
					{/*	value={address1}*/}
					{/*	onChange={setAddress1}*/}
					{/*/>*/}

					{/*<CustomTextFieldNew*/}
					{/*	marginLeft={20}*/}
					{/*	width={'30%'}*/}
					{/*	label={"Address 2"}*/}
					{/*	placeholder={'Detroit MI 48206'}*/}
					{/*	value={address2}*/}
					{/*	onChange={setAddress2}*/}
					{/*/>*/}

					<CustomButtonContained
						style={{height: 50, marginLeft: 2}}
						text={`Search Property`}
						onClick={onSearchPressed}
					/>
				</div>

				{renderAttomData()}
			</div>
		)
	}

	if(loading) {
		return (
			<div className={GeneralStyles.container} style={{height: '100vh', alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
				<CustomLoaderSpinner />
			</div>
		)
	}

	return (
		<div className={GeneralStyles.container}>
			<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative'}}>
				<PageHeader header={'ATTOM Data'}/>
				{/*<CustomButtonContained*/}
				{/*	text={'+ New Reservation'}*/}
				{/*	onClick={onNewReservationClicked}*/}
				{/*	style={{position: 'absolute', right: 40, zIndex: 10}}*/}
				{/*	color={showOverlay ? 'white' : 'primary'}*/}
				{/*/>*/}
			</div>

			<PositionedSnackbar
				onClose={() => {
					setShowError(false)
					setShowSuccess(false)
					setErrorMessage('')
					setSuccessMessage('')
				}}
				severity={showError ? 'error' : 'success'}
				openFlag={showError || showSuccess}
				message={showError ? errorMessage : successMessage}
			/>

			{renderContent()}
		</div>
	)
}

export default Settings
